import React from "react";
import "./FeatureShowcase.css";

const SLOT_DATES = [
  { day: "12", month: "Mar", slots: 3 },
  { day: "13", month: "Mar", slots: 1 },
  { day: "14", month: "Mar", slots: 5 },
  { day: "18", month: "Mar", slots: 2 },
  { day: "21", month: "Mar", slots: 4 },
  { day: "25", month: "Mar", slots: 1 },
];

const TEAM = [
  { initial: "A", name: "Ayesha", role: "Admin", tone: "ok" },
  { initial: "O", name: "Omar", role: "Agent", tone: "accent" },
  { initial: "S", name: "Sara", role: "Client", tone: "info" },
  { initial: "H", name: "Hassan", role: "Agent", tone: "accent" },
];

const STATUSES = [
  { id: "#1842", label: "CHE Tourism", status: "Booked", progress: 100, tone: "ok" },
  { id: "#1839", label: "NLD Visit", status: "In progress", progress: 58, tone: "accent" },
  { id: "#1831", label: "FRA Family", status: "Assigned", progress: 32, tone: "warn" },
  { id: "#1824", label: "DEU Business", status: "Queued", progress: 12, tone: "info" },
];

function SlotsScene() {
  return (
    <div className="fs-scene fs-slots">
      <div className="fs-panel">
        <div className="fs-panel-head">
          <div>
            <strong>Available slots</strong>
            <span>Calendar scan results</span>
          </div>
          <em className="fs-pill ok">Live</em>
        </div>
        <div className="fs-slots-grid">
          {SLOT_DATES.map((item, index) => (
            <div className="fs-slot-card" style={{ "--i": index }} key={`${item.month}-${item.day}`}>
              <b>
                {item.month} {item.day}
              </b>
              <em className="fs-pill accent">{item.slots} slots</em>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function TeamScene() {
  return (
    <div className="fs-scene fs-team">
      <div className="fs-panel">
        <div className="fs-panel-head">
          <div>
            <strong>Team access</strong>
            <span>Roles & permissions</span>
          </div>
        </div>
        <div className="fs-team-list">
          {TEAM.map((member, index) => (
            <div className="fs-team-row" style={{ "--i": index }} key={member.name}>
              <span className={`fs-avatar ${member.tone}`}>{member.initial}</span>
              <div className="fs-team-copy">
                <b>{member.name}</b>
                <span>{member.role}</span>
              </div>
              <em className={`fs-pill ${member.tone}`}>
                {member.role === "Admin" ? "Full access" : member.role === "Client" ? "Bookings" : "VFS + TLS"}
              </em>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function LicenseScene() {
  return (
    <div className="fs-scene fs-license">
      <div className="fs-panel">
        <div className="fs-panel-head">
          <div>
            <strong>Extension license</strong>
            <span>Bridge key linked</span>
          </div>
        </div>
        <div className="fs-license-body">
          <div className="fs-key">
            <span>License key</span>
            <code>VP-9F2A-••••-••••-C81D</code>
          </div>
          <div className="fs-bridge">
            <div className="fs-bridge-node">
              <b>Portal</b>
              <em className="fs-pill ok">Verified</em>
            </div>
            <div className="fs-bridge-line" aria-hidden="true">
              <span />
            </div>
            <div className="fs-bridge-node">
              <b>Extension</b>
              <em className="fs-pill accent">Connected</em>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function StatusScene() {
  return (
    <div className="fs-scene fs-status">
      <div className="fs-panel">
        <div className="fs-panel-head">
          <div>
            <strong>Booking status</strong>
            <span>Assisted jobs end to end</span>
          </div>
        </div>
        <div className="fs-status-list">
          {STATUSES.map((job, index) => (
            <div className="fs-status-row" style={{ "--i": index }} key={job.id}>
              <div className="fs-status-copy">
                <b>
                  {job.id} · {job.label}
                </b>
                <div className="fs-bar">
                  <i style={{ width: `${job.progress}%` }} />
                </div>
              </div>
              <em className={`fs-pill ${job.tone}`}>{job.status}</em>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const SCENES = [SlotsScene, TeamScene, LicenseScene, StatusScene];

/** Animated feature preview that swaps with the active feature index. */
export default function FeatureShowcase({ activeIndex = 0, caption, stepLabel }) {
  return (
    <div className="fs-stage" aria-hidden="true">
      <div className="fs-glow" />
      <div className="fs-orbit" />
      {SCENES.map((Scene, index) => {
        const isActive = index === activeIndex;
        return (
          <div
            key={Scene.name}
            className={`fs-layer${isActive ? " is-active" : ""}`}
          >
            {isActive ? <Scene key={`feature-scene-${activeIndex}`} /> : null}
          </div>
        );
      })}
      <div className="fs-caption">
        <span className="fs-caption-step">{stepLabel}</span>
        <strong>{caption?.title}</strong>
        <span>{caption?.text}</span>
      </div>
    </div>
  );
}
